import {
  getCategories,
  getHomeList
} from '@/calls/events';
import { getLikes } from '@/calls/likes';
import moment from 'moment';
// import Vue from 'vue';

const events = {
  namespaced: true,
  state: {
    limit: 10,
    requests: 0,
    noMore: false,
    noMoreStream: false,
    date: null,
    dates: [
      {
        value: moment().format('YYYY[-]MM[-]DD'),
        start: moment().format('YYYY[-]MM[-]DD'),
        end: moment().format('YYYY[-]MM[-]DD'),
        label: 'Aujourd\'hui'
      },
      {
        value: moment().add(1, 'day').format('YYYY[-]MM[-]DD'),
        start: moment().add(1, 'day').format('YYYY[-]MM[-]DD'),
        end: moment().add(1, 'day').format('YYYY[-]MM[-]DD'),
        label: 'Demain'
      },
      {
        value: moment().add(7, 'days').startOf('isoWeek').format('YYYY[-]MM[-]DD'),
        start: moment().add(7, 'days').startOf('isoWeek').format('YYYY[-]MM[-]DD'),
        end: moment().add(7, 'days').endOf('isoWeek').format('YYYY[-]MM[-]DD'),
        label: 'La semaine prochaine'
      },
      {
        value: moment().add(1, 'month').startOf('month').format('YYYY[-]MM[-]DD'),
        start: moment().add(1, 'month').startOf('month').format('YYYY[-]MM[-]DD'),
        end: moment().add(1, 'month').endOf('month').format('YYYY[-]MM[-]DD'),
        label: 'Le mois prochain'
      }
    ],
    category: null,
    categories: [],
    items: [],
    attractions: [],
    streams: []
  },
  mutations: {
    updateCategory(state, cat) {
      state.category = cat;
    },
    updateDate(state, date) {
      state.date = date;
    },
    setCategories(state, categories) {
      state.categories = [...categories];
    },
    setItems(state, { type, items }) {
      state[type] = [...items];
    },
    addItems(state, { type, items }) {
      // eslint-disable-next-line
      items.map(item => {
        state[type].push(item);
      });
    },
    updateNoMore(state, flag) {
      state.noMore = flag;
    },
    updateNoMoreStream(state, flag) {
      state.noMoreStream = flag;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    },
    updateLikes(state, { event, likes }) {
      state.items.map(item => {
        if (item.id === event) {
          item.likes = likes;
        }

        return item;
      });
    }
  },
  actions: {
    async get({ commit, state }) {
      commit('increaseRequests');
      const request = await getHomeList(
        {
          limit: state.limit,
          offset: 0,
          categoryid: state.category ? state.category.id : null,
          startdate: state.date ? state.date.start : null,
          enddate: state.date ? state.date.end : null
        },
        {
          limit: state.limit,
          offset: 0
        }
      );

      if (request.success) {
        commit('updateNoMore', request.data.attractions.length < state.limit);
        commit('updateNoMoreStream', request.data.streams.length < state.limit);
        commit('setItems', {
          type: 'attractions',
          items: request.data.attractions
        });
        commit('setItems', {
          type: 'streams',
          items: request.data.streams
        });
      }

      commit('decreaseRequests');
    },
    async next({ commit, state }) {
      commit('increaseRequests');

      const request = await getHomeList(
        state.noMore || (state.category && state.category.id === 'streams') ? null : {
          limit: state.limit,
          offset: state.attractions.length,
          categoryid: state.category ? state.category.id : null,
          startdate: state.date ? state.date.start : null,
          enddate: state.date ? state.date.end : null
        },
        state.noMoreStream || (state.category && state.category.id !== 'streams') || state.date ? null : {
          limit: 100,
          offset: state.streams.length
        }
      );

      if (request.success) {
        commit('updateNoMore', request.data.attractions.length < state.limit);
        commit('updateNoMoreStream', true);
        // commit('updateNoMoreStream', request.data.streams.length < state.limit);
        commit('addItems', {
          type: 'attractions',
          items: request.data.attractions
        });
        commit('addItems', {
          type: 'streams',
          items: request.data.streams
        });
      }

      commit('decreaseRequests');
    },
    async categories({ commit }) {
      commit('increaseRequests');

      const request = await getCategories();

      if (request.success) {
        commit('setCategories', request.data);
      }

      commit('decreaseRequests');
    },
    async updateLikes({ commit }, event) {
      const request = await getLikes(event);

      if (request.success) {
        commit('updateLikes', {
          event,
          likes: request.data
        });
      }
    }
  }
};

export default events;
